import { Redirect, Route as ReactDOMRoute } from "react-router-dom";
import { localToken } from "../Services/api";
import { ComponentType } from "react";
interface IRouteProps {
  isPrivate: boolean;
  component: ComponentType;
  path: string;
  exact: boolean;
}

const RouteComponent = ({ isPrivate, component: Component, ...rest }: IRouteProps) => {
  return (
    <ReactDOMRoute
      {...rest}
      render={() => {
        return isPrivate === !!localToken ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? "/" : "/dashboard",
            }}
          />
        );
      }}
    />
  );
};

export default RouteComponent;
